export default {"src":"/_next/static/media/arrow-diagonal-thick-up.1dd8e2f4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};